import {isSameDay, isSameMonth, getYear} from 'date-fns';
// utils
import {fDate} from 'src/utils/format-time';

// ----------------------------------------------------------------------

export function shortDateLabel(startDate, endDate) {
  const getCurrentYear = new Date().getFullYear();

  const startDateYear = startDate ? getYear(startDate) : null;

  const endDateYear = endDate ? getYear(endDate) : null;

  const currentYear = getCurrentYear === startDateYear && getCurrentYear === endDateYear;

  const sameDay = startDate && endDate ? isSameDay(new Date(startDate), new Date(endDate)) : false;

  const sameMonth =
    startDate && endDate ? isSameMonth(new Date(startDate), new Date(endDate)) : false;

  if (currentYear) {
    if (sameMonth) {
      if (sameDay) {
        return fDate(endDate, 'dd MMMM yyyy');
      }
      return `${fDate(startDate, 'dd')}${(startDate && endDate) ? " - " : ""}${fDate(endDate, 'dd MMMM yyyy')}`;
    }
    return `${fDate(startDate, 'dd MMMM')}${(startDate && endDate) ? " - " : ""}${fDate(endDate, 'dd MMMM yyyy')}`;
  }

  return `${fDate(startDate, 'dd MMMM yyyy')}${(startDate && endDate) ? " - " : ""}${fDate(endDate, 'dd MMMM yyyy')}`;
}
